import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FolioService } from '../../services/folio.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <p>{{ message }}</p>

      @if (folio) {
        <!-- C3.4: folio de seguimiento opcional (no rompe usos existentes) -->
        <div class="modal-folio">
          <span class="modal-folio__text">Tu Folio de Seguimiento es:</span>

          <span class="modal-folio__code">{{ folio }}</span>

          <button
            type="button"
            class="btn-copy-folio"
            [class.is-copied]="isFolioCopied"
            [attr.aria-label]="'Copiar folio ' + folio"
            (click)="copyFolio($event)"
          >
            <span *ngIf="!isFolioCopied" aria-hidden="true">⧉</span>
            <span *ngIf="isFolioCopied" aria-hidden="true">✓</span>
          </button>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="activeModal.close('Close click')"
      >
        Close
      </button>
      @if (showSaveButton) {
        <button
          type="button"
          class="btn btn-primary"
          (click)="activeModal.close('Save click')"
        >
          Save
        </button>
      }
    </div>
  `,
  styles: [
    `
      .modal-folio {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        margin-top: 12px;
        padding: 10px 12px;
        border-radius: 8px;
        background: #f1f5f9;
      }
      .modal-folio__text {
        font-size: 0.85rem;
        font-weight: 600;
        color: #334155;
      }
      .modal-folio__code {
        font-family: 'SFMono-Regular', Consolas, monospace;
        font-weight: 700;
        color: #0f172a;
      }
    `,
  ],
})
export class ModalComponent {
  activeModal = inject(NgbActiveModal);
  private readonly folioService = inject(FolioService);

  @Input() title = '';
  @Input() message = '';
  @Input() showSaveButton = false;
  /** C3.4: folio de seguimiento opcional (AC-.../OP-...). Vacío = no se muestra. */
  @Input() folio = '';

  get isFolioCopied(): boolean {
    return this.folioService.lastCopied() === this.folio;
  }

  copyFolio(event: Event): void {
    this.folioService.copyFolio(this.folio, event);
  }
}
